import { ShipmentServiceIncident } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentServiceIncidentController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findAllByShipment(
    shipmentId: number,
  ): Promise<ShipmentServiceIncident[]> {
    const response = await this.http.get<ShipmentServiceIncident[]>(
      `${shipmentId}/incident`,
    );
    return response.data.map((val) => new ShipmentServiceIncident(val));
  }

  async create(
    shipmentId: number,
    incident: ShipmentServiceIncident,
  ): Promise<ShipmentServiceIncident> {
    const response = await this.http.post<ShipmentServiceIncident>(
      `${shipmentId}/incident`,
      incident,
    );
    return new ShipmentServiceIncident(response.data);
  }

  async update(
    shipmentId: number,
    shipmentServiceIncident: ShipmentServiceIncident,
  ): Promise<ShipmentServiceIncident> {
    const response = await this.http.put<ShipmentServiceIncident>(
      `${shipmentId}/incident`,
      shipmentServiceIncident,
    );
    return new ShipmentServiceIncident(response.data);
  }

  async delete(
    shipmentId: number,
    incident: ShipmentServiceIncident,
  ): Promise<ShipmentServiceIncident> {
    if (!incident.id) {
      throw new Error('Id is required to perform delete');
    }
    const response = await this.http.delete<ShipmentServiceIncident>(
      `/${shipmentId}/incident/${incident.id}`,
    );

    return new ShipmentServiceIncident(response.data);
  }
}
